import React, { useState, useEffect, useRef } from "react";
import { ResponsiveContainer, ComposedChart, Line, Area, Tooltip, CartesianGrid, XAxis, YAxis } from "recharts";
import { motion } from "framer-motion";

const CompanyChart = ({ data = [], rawHistory=[], isPositive, ticker, onPriceUpdate }) => {

    const [hoveredData, setHoveredData] = useState([]);
    const [selectedTime, setSelectedTime] = useState([]);
    const [tooltipX, setTooltipX] = useState(0);
    const [displayedPrice, setDisplayedPrice] = useState(0);
    const [displayedChange, setDisplayedChange] = useState(0);
    const [displayedPercentChange, setDisplayedPercentChange] = useState(0);
    const [displayedTimestamp, setDisplayedTimestamp] = useState(0);
    const updatesContainerRef = useRef(null);
    // const [hoveredData, setHoveredData] = useState(marketData[0]);
    // const [selectedTime, setSelectedTime] = useState(marketData[0].time);
    // const [tooltipX, setTooltipX] = useState(0);
    // const updatesContainerRef = useRef(null);

    const [hoverData, setHoverData] = useState(null);
  
    const handleMouseMove = (e) => {
      
      if (e && e.activePayload) {
        const newData = e.activePayload[0]?.payload; // ✅ Use first payload for accuracy
        if (newData) {
          // console.log(newData);
          // console.log(newData);
          // const timestamp = new Date(rawHistory[newData.index].t);

          // console.log(rawHistory[newData.index]);
          // setHoveredData(newData);
          // setDisplayedPrice(rawHistory[newData.index].c);
          // setDisplayedTimestamp(timestamp.toLocaleTimeString("en-US", {
          //   hour: "2-digit",
          //   minute: "2-digit",
          //   timeZone: "America/New_York",
          // }));
          // setDisplayedChange(rawHistory[newData.index].c - rawHistory[newData.index].o);
          // setDisplayedPercentChange((rawHistory[newData.index].c - rawHistory[newData.index].o)/rawHistory[newData.index].o *100);
          // setSelectedTime(newData.time);
          setTooltipX(e.chartX);

          const index = newData.index;
                const timestamp = new Date(rawHistory[index].t);
                const price = rawHistory[index].c;
                const openPrice = rawHistory[index].o;

                const priceChange = price - openPrice;
                const percentageChange = ((priceChange / openPrice) * 100);

          onPriceUpdate({
            price,
            priceChange,
            percentageChange,
            timestamp: rawHistory[index].t,
        });

        }
      }
    };

    const handleMouseLeave = () => {
      onPriceUpdate(null);
      };

  if (!Array.isArray(data) || data.length === 0) {
    return <div style={{ width: "60px", height: "30px", background: "#f3f4f6" }} />;
  }

  // Generate a unique gradient ID per chart
  const gradientId = `colorFill-${ticker}`;

  // Get current time in ET (New York)
  let now = new Date();

  // ✅ 9:30 AM ET in UTC (Eastern Time is UTC -5 or UTC -4 during DST)
  const marketOpen = new Date();
  marketOpen.setUTCHours(12, 30, 0, 0); // 9:30 AM ET -> 13:30 UTC (Standard), 12:30 UTC (DST)
  
  // ✅ 4:00 PM ET in UTC
  const marketClose = new Date();
  marketClose.setUTCHours(20, 0, 0, 0); // 4:00 PM ET -> 20:00 UTC (Standard), 19:00 UTC (DST)
  
  if (now < marketOpen || now > marketClose) {
    marketOpen.setUTCDate(marketOpen.getUTCDate() - 1);
    marketClose.setUTCDate(marketClose.getUTCDate() - 1);
    now = new Date(marketClose); // Set now to yesterday's market close
  }
  // console.log("Start (Market Open):", new Date(marketOpen.getTime()).toLocaleTimeString());
  // console.log("Now:", new Date(now.getTime()).toLocaleTimeString());
  // console.log("End (Market Close):", new Date(marketClose.getTime()).toLocaleTimeString());
  

  const elapsedTime = now.getTime() - marketOpen.getTime();
  const totalMarketTime = marketClose.getTime() - marketOpen.getTime();

  // Calculate how much of the chart should be filled based on time progress
  let progress = Math.max(0, Math.min(1, elapsedTime / totalMarketTime));

  // Ensure chart fills dynamically based on time
  const visibleHistoryLength = Math.ceil(data.length * progress);
  const visibleHistory = data.slice(0, visibleHistoryLength);

  // Calculate the average price of the stock today
  const totalSum = data.reduce((sum, price) => sum + price, 0);
  const avgPrice = data.length > 0 ? totalSum / data.length : 0;

  // Prepare data for Recharts
  const chartData = data.map((price, index) => ({
    index,
    price: index < visibleHistoryLength ? price : null, // Show price up to the current time
    avg: avgPrice, // Gray average line (stays full-width)
  }));

  

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >

      {/* ✅ Display Price & Time above the chart */}
      {/* <div style={{ textAlign: "center", marginBottom: "10px" }}>
        <h2 style={{ fontSize: "24px", fontWeight: "bold" }}>
          ${displayedPrice.toFixed(2)}
        </h2>
        <p style={{ color: displayedChange >= 0 ? "#16a34a" : "#dc2626", fontSize: "18px", fontWeight: "500" }}>
          {displayedChange.toFixed(2)}
        </p>
        <p style={{ color: displayedChange >= 0 ? "#16a34a" : "#dc2626", fontSize: "18px", fontWeight: "500" }}>
          {displayedPercentChange.toFixed(2)}%
        </p>
        <p style={{ fontSize: "14px", color: "#666" }}>
          As of {displayedTimestamp} ET
        </p>
      </div> */}
      
      <ResponsiveContainer width="100%" height={150}> {/* ✅ Full-width & taller */}
<ComposedChart data={chartData} 
onMouseMove={handleMouseMove}
onMouseLeave={handleMouseLeave}
>
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={isPositive ? "#16a34a" : "#dc2626"} stopOpacity={0.4} />
              <stop offset="100%" stopColor={isPositive ? "#16a34a" : "#dc2626"} stopOpacity={0} />
            </linearGradient>
          </defs>

          <Tooltip 
              contentStyle={{ display: "none", backgroundColor: "white", border: "1px solid #ccc", borderRadius: "5px", padding: "5px" }}
              labelStyle={{ fontWeight: "bold" }}
              itemStyle={{ color: "#16a34a" }} // Customize text color
              formatter={(value) => [`$${value.toFixed(2)}`, "Price"]} // ✅ Formats price
          />


          {/* Dashed Gray Average Line (Full-width) */}
          {/* <Line
            type="monotone"
            dataKey="avg"
            stroke={isPositive ? "#16a34a" : "#dc2626"}
            strokeWidth={1}
            strokeDasharray="3 2"
            dot={false}
          /> */}

          {/* Main Stock Trend Line (Stops at current time) */}
          <Area
            type="monotone"
            dataKey="price"
            stroke={isPositive ? "#16a34a" : "#dc2626"}
            fill={`url(#${gradientId})`}
            strokeWidth={1.5}
            dot={false}
          />

        </ComposedChart>
      </ResponsiveContainer>
    </motion.div>
  );
};

export default CompanyChart;
